<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<g id="Group_34782" data-name="Group 34782" transform="translate(-660 -202)">
			<rect id="Rectangle_9624" data-name="Rectangle 9624" width="20" height="20" transform="translate(660 202)" fill="none" />
			<g id="Group_34780" data-name="Group 34780" transform="translate(639.998 187.75)">
				<g id="Group_34778" data-name="Group 34778" transform="translate(23 18)">
					<g id="Group_34648" data-name="Group 34648" transform="translate(0)">
						<path
							id="Path_21163"
							data-name="Path 21163"
							d="M0,11.987V0"
							transform="translate(12.989 2.25) rotate(90)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-miterlimit="10"
							stroke-width="1.5"
						/>
						<path
							id="Path_21294"
							data-name="Path 21294"
							d="M36.37,118.606l-1.951-2,1.951-2"
							transform="translate(-33.417 -114.355)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-miterlimit="10"
							stroke-width="1.5"
						/>
						<path
							id="Path_21295"
							data-name="Path 21295"
							d="M36.37,118.606l-1.951-2,1.951-2"
							transform="translate(47.408 118.855) rotate(180)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-miterlimit="10"
							stroke-width="1.5"
						/>
					</g>
				</g>
				<g id="Group_34779" data-name="Group 34779" transform="translate(23 25.5)">
					<g id="Group_34648-2" data-name="Group 34648" transform="translate(0)">
						<path
							id="Path_21163-2"
							data-name="Path 21163"
							d="M0,11.987V0"
							transform="translate(12.989 2.25) rotate(90)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-miterlimit="10"
							stroke-width="1.5"
						/>
						<path
							id="Path_21294-2"
							data-name="Path 21294"
							d="M36.37,118.606l-1.951-2,1.951-2"
							transform="translate(-33.417 -114.355)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-miterlimit="10"
							stroke-width="1.5"
						/>
						<path
							id="Path_21295-2"
							data-name="Path 21295"
							d="M36.37,118.606l-1.951-2,1.951-2"
							transform="translate(47.408 118.855) rotate(180)"
							fill="none"
							stroke="#5a677d"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-miterlimit="10"
							stroke-width="1.5"
						/>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'MappingIconSvg',
};
</script>

<style scoped lang="scss"></style>
